import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction } from '@api/manage';
export default {
  name: "AssetInventoryModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "资产库存清单表单",
      tableName: "ea_asset_inventory",
      form_fields: ['name', 'quantity', 'siteName', 'contact', 'contactTel', 'status', 'remark'],
      form_fields_time: ['expiryDate', 'purchaseDate'],
      validatorRules: {
        name: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        quantity: {
          rules: [{
            required: true,
            message: '请输入数量!'
          }]
        },
        expiryDate: {
          rules: [{
            required: true,
            message: '请选择保质期!'
          }]
        },
        purchaseDate: {
          rules: [{
            required: true,
            message: '请选择购置日期!'
          }]
        },
        siteName: {
          rules: [{
            required: true,
            message: '请输入贮存点!'
          }]
        },
        contact: {
          rules: [{
            required: true,
            message: '请输入联系人!'
          }]
        },
        contactTel: {
          rules: [{
            required: true,
            message: '请输入联系人电话!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入资产状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    add: function add(params) {
      this.edit(_objectSpread({}, params));
    }
  }
};